import React from 'react';
import styles from './style.module.css';
import StepEightForm from '../../components/forms/step-eight';

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>Mortgage Rate</h1>
        <StepEightForm/>
    </div>
);
